import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/ebay-great-price-badge';

export default function Example() {
  return (
    <>
      <Head>
        <title>eBay Great Price Badge: Your eBay secret to getting your buyers' attention.</title>
        <meta
          name='description'
          content="Catch your potential buyer's attention with the eBay Great Price badge and get more conversions. Learn here how it works and how you can take advantage of this feature."
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/ebay-great-price-badge' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/ebay-great-price-badge' />
        <meta
          property='og:title'
          content="eBay Great Price Badge: Your eBay secret to getting your buyers' attention."
        />
        <meta
          property='og:description'
          content="Catch your potential buyer's attention with the eBay Great Price badge and get more conversions. Learn here how it works and how you can take advantage of this feature."
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='March 29th, 2022' />
        <meta property='article:modified_time' content='March 29th, 2022' />
        <meta property='article:tag' content='eBay' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
